import { defineMessages } from 'react-intl';

export default defineMessages({
  highsAndLows: {
    id: 'WeatherChart.highsAndLows',
    defaultMessage: "{city} High's and Low's Graph",
  },
});
